import * as firebase from 'firebase/app';
import Image from '../models/Image.js';
require('firebase/firestore');
require('firebase/storage');

const state = {
  images: []
};

const getters = {
  getImages: state => state.images
};

const actions = {
  getAllImages({
    commit
  }) {
    firebase.firestore().collection("gallery").onSnapshot(
      snapshot => {
        commit("setLoading", true);

        let images = [];
        snapshot.forEach(doc => {
          let i = new Image(doc.id, doc.data().downloadUrl, doc.data().fullPath, doc.data().name, doc.data().contentType);
          images.push(i);
        });
        commit("setImages", images);
        commit("setLoading", false);
      }
    );
  },
  uploadImages({
    commit
  }, images) {
    let imagesArray = Array.from(images);
    let promiseArray = imagesArray.map((image) => {
      const fileName = image.name;
      const ext = fileName.slice(fileName.lastIndexOf("."));
      const today = new Date();
      const index = imagesArray.indexOf(image);
      const name = index + "-" + today.getTime();

      return firebase.storage().ref("gallery/" + name + ext).put(image)
        .then((fileData) => {
          console.log("One Success: ", image.name);
          let url = fileData.metadata.downloadURLs[0];
          return firebase.firestore().collection("gallery").add({
            downloadUrl: fileData.metadata.downloadURLs[0],
            fullPath: fileData.metadata.fullPath,
            name: fileData.metadata.name,
            contentType: fileData.metadata.contentType
          });
        }).then(() => {
          console.log("Added entry for " + image.name + " metadata");
        }).catch((error) => {
          console.log("Error: ", image.name, error.message);
        });
    });

    Promise.all(
      promiseArray
    ).then(() => {
      console.log("All success!")
    }).catch((error) => {
      console.log("Some failed: ", error);
    });
  },
  removeImage({
    commit
  }, toRemove) {
    let imageRef = firebase.storage().ref().child(toRemove.fullPath);

    imageRef.delete().then((result) => {
      console.log("Deleted file");
      return firebase.firestore().collection('gallery').doc(toRemove.id).delete();
    }).then((result) => {
      console.log("Deleted entry");
    }).catch(error => {
      console.log("Error: ", error);
    })
  }
};

const mutations = {
  setImages(state, images) {
    state.images = images;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
};